document.addEventListener('DOMContentLoaded', function () {
  const backToTopButton = document.querySelector('[data-back-to-top]');
  if (!backToTopButton) return;

  const toggleBackToTop = () => {
    if (window.scrollY > 400) {
      backToTopButton.classList.add('is-visible');
    } else {
      backToTopButton.classList.remove('is-visible');
    }
  };

  toggleBackToTop();

  window.addEventListener('scroll', toggleBackToTop, { passive: true });

  backToTopButton.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  });
});